import React from "react";
import "./MoreServices.css";
import { motion } from "framer-motion";
import atmsImg from "../../assets/atms.jpg"; // add your image
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackward, faForward } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Atms() {
  const leftVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  };

  return (
    <>
      <h2 className="ecommerce-heading">
        Advanced Traffic Management System
      </h2>

      <div className="service-container" id="top">
        <div className="service-data-container">

          {/* IMAGE */}
          <div className="image-container">
            <p className="hover-text">
              Smart and automated traffic management solutions designed to improve monitoring, control, and operational efficiency.
            </p>
            <img className="img-moredetails" src={atmsImg} alt="ATMS" />
          </div>

          {/* CONTENT */}
          <div className="content-section">
            <motion.h1
              className="fw-bold mt-5"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={leftVariants}
            >
              Growbean: ATMS Solutions
            </motion.h1>

            <motion.p className="mt-3 text-body-secondary" variants={leftVariants}>
              Growbean’s Advanced Traffic Management System (ATMS) provides smart monitoring,
              automation, and centralized control solutions to enhance system efficiency
              and enable better decision-making across multiple environments.
            </motion.p>

            <motion.h2
  className="fw-bold"
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.1 }}
  variants={leftVariants}
>
  Advanced Traffic Management System (ATMS)
</motion.h2>

<motion.p className="text-body-secondary" variants={leftVariants}>
  Growbean’s Advanced Traffic Management System (ATMS) is designed to provide smart monitoring,
  automation, and centralized control for efficient system operations. It helps organizations
  manage vehicle movement, analyze real-time data, and streamline processes through intelligent solutions.
</motion.p>

<br />

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">1. Smart Monitoring:</span>{" "}
  Enables continuous monitoring of vehicle movement and activities across multiple locations,
  providing better visibility and control over system operations.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">2. Real-time Insights:</span>{" "}
  Delivers real-time data and insights that help in quick decision-making,
  improving efficiency and overall system performance.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">3. Automated Operations:</span>{" "}
  Supports automation of routine processes, reducing manual intervention
  and increasing operational efficiency.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">4. Centralized Control:</span>{" "}
  Provides a centralized platform to manage and control multiple systems and locations
  from a single interface.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">5. Vehicle Classification:</span>{" "}
  Classifies vehicles into different categories such as cars, trucks, buses, and two-wheelers,
  enabling better analysis and structured data handling.
</motion.p>

<motion.p className="text-body-secondary" variants={leftVariants}>
  <span className="text-black fw-bold">6. Vehicle Detection:</span>{" "}
  Detects and tracks vehicle presence in real-time, supporting monitoring,
  automation, and efficient system operations.
</motion.p>
          </div>
        </div>
      </div>

      {/* NAVIGATION */}
      <div className="d-flex justify-content-around m-5">
        <Link to="/services">
          <button className="bn53">
            <FontAwesomeIcon icon={faBackward} /> Prev
          </button>
        </Link>
        <Link to="/itms">
          <button className="bn53">
            Next <FontAwesomeIcon icon={faForward} />
          </button>
        </Link>
      </div>
    </>
  );
}

export default Atms;